import React from "react";
import { Form } from "react-final-form";
import { useAuth } from "@syos-music/auth";
import { Dialog } from "@syos-music/common";
import { DateField } from "@syos-music/form";
import qs from "qs";

import { Button, Grid } from "@mui/material";
import { LoadingButton } from "@mui/lab";

const clearDateTime = (date) => {
  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setMilliseconds(0);
};

export default function UkExport({ invoice, children }) {
  const auth = useAuth();

  const [isOpen, setIsOpen] = React.useState(false);

  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  const initialStartDate = new Date();
  initialStartDate.setDate(1);
  clearDateTime(initialStartDate);

  const initialEndDate = new Date(
    initialStartDate.getFullYear(),
    initialStartDate.getMonth() + 1,
    initialStartDate.getDay()
  );

  return (
    <>
      {children({ isOpen, open, close })}

      <Dialog open={isOpen} onClose={close}>
        <Form
          onSubmit={async ({ startDate, endDate }) => {
            const accessToken = await auth.getAccessToken();

            const query = qs.stringify({
              startDate: startDate.toISOString(),
              endDate: endDate.toISOString(),
            });

            // prettier-ignore
            const fetchUrl = `${process.env.REACT_APP_API_BASE_URL}/billing/uk.csv?${query}`
            const headers = { authorization: `Bearer ${accessToken}` };

            const blob = await fetch(fetchUrl, { headers }).then((res) =>
              res.blob()
            );

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "export-uk.csv";
            a.click();

            window.URL.revokeObjectURL(url);
          }}
          initialValues={{
            startDate: initialStartDate,
            endDate: initialEndDate,
          }}
          keepDirtyOnReinitialize
        >
          {({ handleSubmit, submitting }) => (
            <form onSubmit={handleSubmit} noValidate autoComplete="off">
              <Dialog.Title color="primary">Générer un export UK</Dialog.Title>

              <Dialog.Content dividers>
                <Grid container>
                  <Grid item xs={12} sm={6}>
                    <DateField name="startDate" required label="Début" />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <DateField name="endDate" required label="Fin" />
                  </Grid>
                </Grid>
              </Dialog.Content>

              <Dialog.Actions>
                <Button variant="text" onClick={close}>
                  Annuler
                </Button>

                <LoadingButton type="submit" loading={submitting}>
                  Générer
                </LoadingButton>
              </Dialog.Actions>
            </form>
          )}
        </Form>
      </Dialog>
    </>
  );
}
